import { Col, Row, Checkbox } from 'antd'
import Input from 'components/Form/Input'
import React, { useState, useEffect } from 'react'
import styled from 'styled-components'

const Label = styled.div`
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
`

const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
`

const ArrearsFilter = ({ state, handleArrearsChange, checkArrears }) => {
  const [pastComparisonType, setPastComparisonType] = useState('')
  const [currentComparisonType, setCurrentComparisonType] = useState('')

  useEffect(() => {
    if (checkArrears?.pastType === 'GTE') {
      setPastComparisonType('greaterThan')
    } else if (checkArrears?.pastType === 'LTE') {
      setPastComparisonType('lessThan')
    } else {
      setPastComparisonType('')
    }

    if (checkArrears?.currentType === 'GTE') {
      setCurrentComparisonType('greaterThan')
    } else if (checkArrears?.currentType === 'LTE') {
      setCurrentComparisonType('lessThan')
    } else {
      setCurrentComparisonType('')
    }
  }, [checkArrears?.pastType, checkArrears?.currentType])

  const handleComparisonChange = (type, value) => {
    const isSame = (type === 'past' ? pastComparisonType : currentComparisonType) === value
    const newValue = isSame ? '' : value

    if (type === 'past') {
      setPastComparisonType(newValue)
      const updatedArrears = {
        ...checkArrears,
        pastType: newValue === 'greaterThan' ? 'GTE' : newValue === 'lessThan' ? 'LTE' : '',
        ...(newValue === '' && { past: '' })
      }
      handleArrearsChange(updatedArrears)
    } else {
      setCurrentComparisonType(newValue)
      const updatedArrears = {
        ...checkArrears,
        currentType: newValue === 'greaterThan' ? 'GTE' : newValue === 'lessThan' ? 'LTE' : '',
        ...(newValue === '' && { current: '' })
      }
      handleArrearsChange(updatedArrears)
    }
  }

  const handleInputChange = (field, value) => {
    // Only allow numbers and empty string
    const numericValue = value.replace(/[^0-9]/g, '')

    if (
      numericValue === '' ||
      (parseInt(numericValue) >= 0 && parseInt(numericValue) < 100)
    ) {
      const updates = {
        ...checkArrears,
        [field]: numericValue,
      }
      
      if (numericValue !== '') {
        if (field === 'past' && !checkArrears.pastType) {
          updates.pastType = 'LTE'
          setPastComparisonType('lessThan')
        }
        if (field === 'current' && !checkArrears.currentType) {
          updates.currentType = 'LTE'
          setCurrentComparisonType('lessThan')
        }
      }
      
      handleArrearsChange(updates)
    }
  }

  return (
    <Row gutter={16}>
      <Col span={12}>
        <Label>History Of Arrears</Label>
        <CheckboxContainer>
          <Checkbox
            checked={pastComparisonType === 'lessThan'}
            onChange={() => handleComparisonChange('past', 'lessThan')}
          >
            ≤ Lesser than or Equal to
          </Checkbox>
          <Checkbox
            checked={pastComparisonType === 'greaterThan'}
            onChange={() => handleComparisonChange('past', 'greaterThan')}
          >
            ≥ Greater than or Equal to
          </Checkbox>
        </CheckboxContainer>
        <Input
          width="100%"
          placeholder="Enter Past Arrears"
          type="text"
          name="pastArrears"
          value={checkArrears?.past || ''}
          onChange={e => handleInputChange('past', e.target.value)}
          maxLength={2}
        />
      </Col>
      <Col span={12}>
        <Label>Current Arrears</Label>
        <CheckboxContainer>
          <Checkbox
            checked={currentComparisonType === 'lessThan'}
            onChange={() => handleComparisonChange('current', 'lessThan')}
          >
            ≤ Lesser than or Equal to
          </Checkbox>
          <Checkbox
            checked={currentComparisonType === 'greaterThan'}
            onChange={() => handleComparisonChange('current', 'greaterThan')}
          >
            ≥ Greater than or Equal to
          </Checkbox>
        </CheckboxContainer>
        <Input
          width="100%"
          placeholder="Enter Current Arrears"
          type="text"
          name="currentArrears"
          value={checkArrears?.current || ''}
          onChange={e => handleInputChange('current', e.target.value)}
          maxLength={2}
        />
      </Col>
    </Row>
  )
}

export default ArrearsFilter
